import { Container } from "reactstrap"
import logo from "../assets/images/logo.png"

function NotFound() {
    return (
        <Container className="d-flex justify-content-center align-items-center flex-column" style={{ height: "100vh" }}>
            <img src={logo} width="300" />
            <div className="text-center">OOPS! Page that are you looking for has been removed or does not exist.</div>
        </Container>
    );
}

export default NotFound;